import { useSettingsStore } from "@/data/settingsStore";

export const BAROMETER_MODE_KEY = "kaynin_barometer_mode";
export const BAROMETER_ENABLED_KEY = "kaynin_barometer_enabled";

export type BarometerMode = "accreditation" | "election";

export function getBarometerMode(): BarometerMode {
  return useSettingsStore.getState().getSetting(BAROMETER_MODE_KEY, "accreditation") as BarometerMode;
}

export function setBarometerMode(mode: BarometerMode) {
  useSettingsStore.getState().updateSetting(BAROMETER_MODE_KEY, mode);
}

export function isBarometerEnabled(): boolean {
  return useSettingsStore.getState().getSetting(BAROMETER_ENABLED_KEY, true) as boolean;
}

export function setBarometerEnabled(enabled: boolean) {
  useSettingsStore.getState().updateSetting(BAROMETER_ENABLED_KEY, enabled);
}
